import { useEffect } from 'react';
import { NavBar } from '../components/NavBar';
import { HeroSection } from '../components/HeroSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { SubPortalSection } from '../components/SubPortalSection';
import { BuiltForSection } from '../components/BuiltForSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { LeadCaptureSection } from '../components/LeadCaptureSection';
import { Footer } from '../components/Footer';

export function LandingPage() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    );

    const els = document.querySelectorAll('.reveal');
    for (const el of els) {
      observer.observe(el);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#111111] text-zinc-100">
      <NavBar />
      <HeroSection />
      <HowItWorksSection />
      <FeaturesSection />
      <SubPortalSection />
      <BuiltForSection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <LeadCaptureSection />
      <Footer />
    </div>
  );
}
